/**
 * `String.prototype.replace` with the replacement inserted literally.
 *
 * A string passed as the replacement is a *pattern*, not text: `$&` expands to
 * the whole match, `` $` `` and `$'` to everything before and after it, and
 * `$1` to a capture group. So any `replace` whose replacement is computed —
 * interpolated GLSL, a user-entered field, anything read from the database —
 * silently rewrites itself when the replacement happens to contain a dollar
 * sign. Two instances of this class were live in the repo at once: patched
 * shader chunks built by template interpolation, and the plan-header fields of
 * a generated PDF, where a customer name containing `$&` duplicated the
 * `{{ VAR }}` token and `$'` spliced the rest of the template into the field.
 *
 * A function replacement is not interpreted, which is the whole fix. Use these
 * helpers rather than hand-writing `() => replacement`, so
 * `check-verbatim-replace` can tell a safe call from an unreviewed one.
 */
export function replaceVerbatim(
  haystack: string,
  pattern: string | RegExp,
  replacement: string,
): string {
  return haystack.replace(pattern, () => replacement);
}

/** As {@link replaceVerbatim}, for every occurrence. */
export function replaceAllVerbatim(
  haystack: string,
  pattern: string | RegExp,
  replacement: string,
): string {
  return haystack.replaceAll(pattern, () => replacement);
}
